import script from "./TheFooterComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheFooterComponent.vue?vue&type=script&lang=ts&setup=true"

import "./TheFooterComponent.scss?vue&type=style&index=0&id=0f07ddda&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f07ddda"]])

export default __exports__